import { createContext, useContext, useState, useCallback, useEffect } from "react";

const LANG_KEY = "site_lang";

function getStoredLang() {
  try { return localStorage.getItem(LANG_KEY) || "es"; } catch { return "es"; }
}

export const LanguageContext = createContext({ lang: "es", setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(getStoredLang);

  useEffect(() => {
    const handler = () => setLangState(getStoredLang());
    window.addEventListener("langchange", handler);
    return () => window.removeEventListener("langchange", handler);
  }, []);

  const setLang = useCallback((l) => {
    try { localStorage.setItem(LANG_KEY, l); } catch {}
    setLangState(l);
    window.dispatchEvent(new Event("langchange"));
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const [lang, setLangState] = useState(getStoredLang);

  useEffect(() => {
    const handler = () => setLangState(getStoredLang());
    window.addEventListener("langchange", handler);
    return () => window.removeEventListener("langchange", handler);
  }, []);

  const setLang = useCallback((l) => {
    try { localStorage.setItem(LANG_KEY, l); } catch {}
    setLangState(l);
    window.dispatchEvent(new Event("langchange"));
  }, []);

  return { lang, setLang };
}